import DecimalSetting from "./decimal-setting";
import EInvoiceDetailSetting from "./e-invoice-detail-setting";

export default {
  name: 'EInvoiceConfiguration',
  components: {
    DecimalSetting,
    EInvoiceDetailSetting
  },
  data() {
    return {
      // Keyword là KHÓA dịch; Fallback là câu tiếng Việt cũ, dùng khi môi trường chưa seed khóa.
      settingOptions: [
        {
          SettingId: '1',
          Keyword: 'e_invoice_configuration_menu_decimal',
          Fallback: 'Số thập phân',
        },
        {
          SettingId: '2',
          Keyword: 'e_invoice_configuration_menu_invoice_detail',
          Fallback: 'Chi tiết hóa đơn',
        }
      ],
      eInvoiceDetailOptions: [
        {
          DetailId: '1',
          Keyword: 'Hóa đơn điện tử',
        },
        {
          DetailId: '2',
          Keyword: 'Vé'
        }
      ],
      lv1Active: null,
      lv2Active: null,

    }
  },
  computed: {
    //TODO: Check user role

    // ...mapState({
    //   currentSiteID: (state) => state.auth.user.SiteID,
    //   $ls_GroupUserRoles: (state) => state.app.resources.GroupUsers,
    // }),
    // ...mapGetters({
    //   $lsGet_userSiteGroupRoleInfo: 'app/userSiteGroupRoleInfo'
    // }),
    // currentUserSiteGroupRoleInfo() {
    //   return this.$lsGet_userSiteGroupRoleInfo(this.currentSiteID);
    // },
    // groupRolesAllowConfig() {
    //   if (this.currentUserSiteGroupRoleInfo) {
    //     return this.$ls_GroupUserRoles
    //       .filter(s => s.GroupRoleLevel > this.currentUserSiteGroupRoleInfo.GroupRoleLevel)
    //       .sort((a, b) => a.GroupRoleLevel - b.GroupRoleLevel);
    //   }
    //   return [];
    // },

    isDecimalSetting() {
      return !!this.settingOptions.find(setting => setting.SettingId === this.lv1Active);
    }
  },
  methods: {
    /**
     * Dịch theo khóa; khóa chưa được seed thì hiện câu tiếng Việt cũ thay vì lộ tên khóa. (Trước đây màn này
     * dùng thẳng câu tiếng Việt làm khóa — cột KeywordCode là varchar nên không seed được, sang tiếng Anh vẫn ra
     * tiếng Việt.)
     */
    tOr(key, fallback) {
      return this.$te(key) ? this.$t(key) : fallback;
    },

    setLv1Active(settingId) {
      this.lv1Active = settingId;
    }
  },

}